import { Icon } from "../Icon";

interface CalloutProps {
  children: React.ReactNode;
  variant?: "notice";
}

export const Callout = ({ children, variant = "notice" }: CalloutProps) => {
  const variantClasses = {
    notice: "bg-notice-25 [&>.icon]:text-notice",
  };

  return (
    <div className={`flex w-full items-center gap-2 p-2 ${variantClasses[variant]}`}>
      <Icon name="Warning" />
      <p>{children}</p>
    </div>
  );
};
